import { MutationTree } from 'vuex';
import { UserState } from "./types";

export const mutations: MutationTree<UserState> = { 

    setTest(state, payload: string) {
        state.test = payload
    },

}